import { render, staticRenderFns } from "./ReportesLectorCodigoPatrocinadores.vue?vue&type=template&id=73b6bd05&"
import script from "./ReportesLectorCodigoPatrocinadores.vue?vue&type=script&lang=js&"
export * from "./ReportesLectorCodigoPatrocinadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports